<template>
  <div class="dashboard">
    <!-- 固定顶部导航栏 -->
    <div class="fixed-header">
      <div class="sub-header">
        <div class="head_info">
          <span>
            {{ $store.state.userName }}
            <b v-if="$store.state.roleName">
              {{ $store.state.roleName }}
            </b>
          </span>
          <img @click="Logout" src="@/assets/images/out.png" alt="" />
        </div>
        <div class="head_tab">
          <span @click="active = '1'" :class="active == '1' ? 'active' : ''">
            概览<u></u>
          </span>
          <span @click="active = '2'" :class="active == '2' ? 'active' : ''">
            数据<u></u>
          </span>
        </div>
      </div>
    </div>
    <overview v-if="active == '1'"></overview>
    <dataIndex v-if="active == '2'"></dataIndex>

    <!-- <app-tab-bar /> -->
  </div>
</template>

<script>
// import AppTabBar from "@/components/TabBar.vue";
import dataIndex from "./homeCategory/data.vue";
import overview from "./homeCategory/overview.vue";

export default {
  name: "HomePage",
  components: {
    // AppTabBar,
    dataIndex,
    overview,
  },
  data() {
    return {
      active: "1",
    };
  },
  async created() {},

  mounted() {},
  beforeDestroy() {},
  methods: {

    // 退出登录
    Logout() {
      this.$dialog
        .confirm({
          title: "退出登录",
          message: "确认退出登录吗？",
        })
        .then(() => {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.dashboard {
  height: 100vh;
  display: flex;
  flex-direction: column;

  .fixed-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background: #ffffff;
    height: 106px;
    .sub-header {
      width: 100%;
      height: 100%;
      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.1),
        0px 0px 6px 0px rgba(0, 0, 0, 0.09), 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      border-radius: 0px 0px 6px 6px;
      border: 1px solid #ffffff;
      padding: 0 12px;
      box-sizing: border-box;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .head_info {
        display: flex;
        justify-content: space-between;
        font-family: PingFang SC;
        font-weight: 600;
        font-size: 20px;
        line-height: 20px;
        margin-top: 30px;
        span {
          display: flex;
          align-items: center;
          b {
            width: 55px;
            height: 21px;
            background: #f4f4f4;
            border-radius: 2px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #7f7f7f;
            margin-left: 14px;
            text-align: center;
            line-height: 21px;
          }
        }
        img {
          width: 20px;
          height: 20px;
        }
      }
      .head_tab {
        margin-bottom: 6px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        span {
          display: inline-block;
          width: 36px;
          color: #999999;
          position: relative;
          text-align: center;
          u {
            position: absolute;
            bottom: -1px;
            width: 14px;
            left: 50%;
            margin-left: -10px;
            border: none;
          }
        }
        .active {
          color: #000000;
          u {
            border: 1px solid #000000;
          }
        }
      }
    }
  }
}
</style>
